import * as angular from 'angular';
import {IController} from "angular";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {ProcessTrackingStatus} from "../../types/process-tracking-status.enum";
import * as _ from "lodash";

export class CustomOrderPlanningMonitorViewComponent implements IController {

  from: number;
  to: number;
  processStatus: string[];
  hasRoute: boolean | null;
  branchIds: string[];
  agentIds: string[];
  resourceIds: string[];

  public filterConfig: any;
  public monitorData: any[];
  public infiniteScroll: any;
  public loadLimit: number = 20;
  public hasMonitoringPermission: boolean;
  public processTrackingRef: any;
  public selectedQuickFilterId: string;
  public pageName: string = 'order-planning-monitor';
  public processStatusOptions: string[] = Object.values(ProcessTrackingStatus);

  public routeCreationSuccessful?: boolean;
  public routeAssigningSuccessful?: boolean;

  constructor(private $infiniteScroll,
              private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private $state,
              private IAMPermissions,
              private $processTracking) {
  }

  $onInit() {
    // Check permissions
    this.hasMonitoringPermission = this.IAMPermissions.hasPermission('customOrderPlanning.monitoring.get') ||
                                   this.IAMPermissions.hasPermission('customOrderPlanning.dashboard.get');


    // Initialize filter configuration
    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDefaultCustomTemplates(),
      range: this.from && this.to ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.today(),
      queryString: undefined,
      includeFilters: [
        SiteFiltersType.branchIds,    // Branch IDs
        SiteFiltersType.agentIds,     // Agent IDs
        SiteFiltersType.resourceIds   // Resource allocation IDs
      ], // Available filters for the filters button
      excludeIdsMap: {},
      optionIdsMap: {},
      queryMap: {},
      bringozFilters: {

        [SiteFiltersType.branchIds]: this.branchIds || [],      // Branch IDs
        [SiteFiltersType.agentIds]: this.agentIds || [],        // Agent IDs
        [SiteFiltersType.resourceIds]: this.resourceIds || []   // Resource allocation IDs
      }
    };

    if (this.hasMonitoringPermission) {
      // Initialize process tracking API reference
      this.processTrackingRef = this.$processTracking();

      // Query data from API
      this.processTrackingRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.processTrackingRef, this.loadLimit, {getFullData: true});
    }
  }

  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  submitQuery(query: string) {
    this.filterConfig.queryString = query;
    this._query();
  }

  onChangeProcessStatus(selectedIds: string[]) {
    this.filterConfig.bringozFilters.processStatus = selectedIds;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  onChangeHasRoute(hasRoute: boolean | null) {
    // Value is already updated via ng-model binding
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  onChangeRouteCreationSuccessful(routeCreationSuccessful: boolean | null) {
    this.routeCreationSuccessful = routeCreationSuccessful;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  onChangeRouteAssigningSuccessful(routeAssigningSuccessful: boolean | null) {
    this.routeAssigningSuccessful = routeAssigningSuccessful;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  onQuickFilterSelect(selectedItem: any) {
    this.selectedQuickFilterId = selectedItem?.id;
    if (selectedItem?.filters) {
      // Apply quick filter settings
      this.filterConfig.bringozFilters = {...this.filterConfig.bringozFilters, ...selectedItem.filters};
    }
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  onFiltersChange(filters: any, selectedQuickFilter: any) {
    this.filterConfig.bringozFilters = {...this.filterConfig.bringozFilters, ...filters};
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
    this._query();
  }

  private _query() {
    if (this.hasMonitoringPermission && this.processTrackingRef) {
      // Query the API with current filters
      this.processTrackingRef.$query(this._getQueryPayload());

      // Reset and reload infinite scroll
      if (this.infiniteScroll) {
        this.infiniteScroll.reload();
      }
    }
  }

  private _getQueryPayload() {
    const filterConfig = this.filterConfig;
    const bringozFilters = filterConfig.bringozFilters;

    return {
      from: filterConfig.range.dateStart,
      to: filterConfig.range.dateEnd,
      queryString: filterConfig.queryString,
      processStatus: bringozFilters.processStatus,
      hasRoute: bringozFilters.hasRoute === null ? undefined : bringozFilters.hasRoute,
      routeCreationFailed: _.isBoolean(this.routeCreationSuccessful) ? !this.routeCreationSuccessful : undefined,
      routeAssigningFailed: _.isBoolean(this.routeAssigningSuccessful) ? !this.routeAssigningSuccessful : undefined,
      branchIds: bringozFilters[SiteFiltersType.branchIds],
      agentIds: bringozFilters[SiteFiltersType.agentIds],
      resourceIds: bringozFilters[SiteFiltersType.resourceIds],
      offset: 0,
      limit: this.loadLimit
    };
  }

  private _getQueryParams() {
    const filterConfig = this.filterConfig;
    const bringozFilters = filterConfig.bringozFilters;

    return {
      from: filterConfig.range.dateStart,
      to: filterConfig.range.dateEnd,
      processStatus: _.isEmpty(bringozFilters.processStatus) ? undefined : bringozFilters.processStatus,
      hasRoute: bringozFilters.hasRoute === null ? undefined : bringozFilters.hasRoute,
      // routeCreationSuccessful: this.routeCreationSuccessful === null ? undefined : this.routeCreationSuccessful,
      // routeAssigningSuccessful: this.routeAssigningSuccessful === null ? undefined : this.routeAssigningSuccessful,
      branchIds: _.isEmpty(bringozFilters[SiteFiltersType.branchIds]) ? undefined : bringozFilters[SiteFiltersType.branchIds],
      agentIds: _.isEmpty(bringozFilters[SiteFiltersType.agentIds]) ? undefined : bringozFilters[SiteFiltersType.agentIds],
      resourceIds: _.isEmpty(bringozFilters[SiteFiltersType.resourceIds]) ? undefined : bringozFilters[SiteFiltersType.resourceIds],
      selectedQuickFilterId: this.selectedQuickFilterId
    };
  }
}

// Component registration
angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningMonitorView', {
    controller: CustomOrderPlanningMonitorViewComponent,
    controllerAs: '$ctrl',
    template: require('./custom-order-planning-monitor-view.html').default,
    bindings: {
      from: '<',
      to: '<',
      processStatus: '<',
      hasRoute: '<?',
      branchIds: '<',
      agentIds: '<',
      resourceIds: '<',
      selectedQuickFilterId: '<'
    }
  });
